export default function DashboardHeader({
  activeTab,
  setActiveTab,
  handleLogout,
}) {
  return (
    <div className="flex items-center justify-between mb-10">

      <div>
        <p className="text-sm uppercase tracking-[0.2em] text-sage-600">
          Anara Lifethread
        </p>

        <h1 className="font-serif text-4xl text-ink">
          Admin Dashboard
        </h1>

        <p className="text-ink-muted">
          Manage customer enquiries and service requests.
        </p>
      </div>

      <div className="flex gap-3">
        <button
          onClick={() => setActiveTab("signups")}
          className={activeTab === "signups"
            ? "px-5 py-2 rounded-xl bg-sage-600 text-white"
            : "px-5 py-2 rounded-xl bg-gray-100"}
        >
          Signups
        </button>

        <button
          onClick={() => setActiveTab("contacts")}
          className={activeTab === "contacts"
            ? "px-5 py-2 rounded-xl bg-sage-600 text-white"
            : "px-5 py-2 rounded-xl bg-gray-100"}
        >
          Contacts
        </button>

        <button
          onClick={() => setActiveTab("waiting")}
          className={activeTab === "waiting"
            ? "px-5 py-2 rounded-xl bg-sage-600 text-white"
            : "px-5 py-2 rounded-xl bg-gray-100"}
        >
          Waiting
        </button>
        <button
  onClick={() => setActiveTab("serviceEnquiries")}
  className={
    activeTab === "serviceEnquiries"
      ? "px-5 py-2 rounded-xl bg-sage-600 text-white"
      : "px-5 py-2 rounded-xl bg-gray-100"
  }
>
  Service Enquiries
</button>
<button
  onClick={() => setActiveTab("jobApplications")}
  className={
    activeTab === "jobApplications"
      ? "px-5 py-2 rounded-xl bg-sage-600 text-white"
      : "px-5 py-2 rounded-xl bg-gray-100"
  }
>
  Job Applications
</button>

        <button
          onClick={handleLogout}
          className="border border-sage-600 rounded-full px-5 py-2"
        >
          Logout
        </button>
      </div>

    </div>
  );
}